import ajax from '../../lib/ajax'

// TenantInfo
// 中心信息查询
export async function TenantInfo(payload: any) {
    let res = await ajax.post('api/services/app/BasicData/TenantInfo', payload, true)
    return res.data.result
}
// EditTenantInfo
// 中心管理编辑
export async function EditTenantInfo(payload: any) {
    let res = await ajax.post('api/services/app/BasicData/EditTenantInfo', payload, false)
    return res.data.result
}
// 中心管理编辑
export async function TenantInfoExt(payload: any) {
    let res = await ajax.post('api/services/app/BasicData/TenantInfoExt', payload, false)
    return res.data.result
}